import { useMemo } from "react";
import { ImageLite, Paragraph } from "shared/components";
import { useLazyRenderingState } from "shared/components/LazyRenderingButton";
import { useViewMode } from "shared/contexts/ViewMode";

import styles from "./Items.module.scss";

export const Items = ({ items }) => {
  const { isDesktop } = useViewMode();
  const { limit } = useLazyRenderingState();
  const gridSize = isDesktop ? 4 : 2;

  const slicedItems = useMemo(() => {
    return items.slice(0, limit);
  }, [limit, items]);

  const groupedItems = useMemo(() => {
    const source = [...slicedItems];
    const result = [];
    let index = 0;

    while (source.length > 0) {
      result.push({
        key: `group_${index++}`,
        items: source.splice(0, gridSize),
      });
    }

    return result;
  }, [gridSize, slicedItems]);

  const style = useMemo(
    () => ({
      gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
    }),
    [gridSize]
  );

  return groupedItems.map((group) => (
    <div className={styles.row} key={group.key} style={style}>
      {group.items.map((item) => (
        <div className={styles.item} key={item.id}>
          <ImageLite image={item.logo} className={styles.image} />
          <Paragraph color="grey" className={styles.title} appearance="bigger">
            {item.title}
          </Paragraph>
        </div>
      ))}
    </div>
  ));
};
